import { useState } from 'react';
import { api, ApiCallError, clearSession } from '../api/client';
import type { Parent } from '@xiaopeiban/shared';

export default function SettingsPage({ parent, onLogout }: { parent: Parent; onLogout: () => void }) {
  const [newPassword, setNewPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  async function changePassword() {
    setErr(null); setOk(null);
    if (newPassword.length < 4) { setErr('密码至少 4 位'); return; }
    try {
      await api.setPassword(newPassword);
      setOk('密码已更新');
      setNewPassword('');
    } catch (e) { setErr(niceError(e)); }
  }

  async function logout() {
    try { await api.logout(); } catch {/* ignore */}
    clearSession();
    onLogout();
  }

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-title">⚙️ 设置</div>
      </div>

      <div className="card">
        <div style={{ fontWeight: 700, marginBottom: 12 }}>账号信息</div>
        <div className="muted" style={{ fontSize: 13 }}>邮箱</div>
        <div style={{ marginBottom: 12 }}>{parent.email}</div>
        <div className="muted" style={{ fontSize: 13 }}>状态</div>
        <div>
          邮箱 {parent.email_verified ? '✅ 已验证' : '⚠️ 未验证'}
          {parent.has_password ? ' · 🔒 已设密码' : ' · 未设密码'}
        </div>
      </div>

      <div className="card">
        <div style={{ fontWeight: 700, marginBottom: 12 }}>
          {parent.has_password ? '修改密码' : '设置密码'}
        </div>
        <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>
          {parent.has_password
            ? '输入新密码，以后可用"邮箱+密码"登录，不用每次都发验证码。'
            : '设置密码后，以后可以用邮箱+密码直接登录，不用每次都等验证码。'}
        </div>
        <input
          type="password"
          autoComplete="new-password"
          placeholder="至少 4 位"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && changePassword()}
        />
        {err && <div className="error-box">{err}</div>}
        {ok && <div className="success-box">{ok}</div>}
        <button className="btn btn-primary btn-block" style={{ marginTop: 12 }} onClick={changePassword}>
          保存
        </button>
      </div>

      <div className="card">
        <div style={{ fontWeight: 700, marginBottom: 12 }}>登出</div>
        <button className="btn btn-danger btn-block" onClick={logout}>
          退出家长后台
        </button>
      </div>
    </div>
  );
}

function niceError(e: unknown): string {
  if (e instanceof ApiCallError) return e.message;
  return (e as Error)?.message || '出错了';
}
